<label [ngClass]="{'disabledText': disabled}" *ngIf="label">
    {{label}}
    <span *ngIf="required && !hideRequiredMarker" style="color:red;">&nbsp;*</span>
</label>
<mat-chip-list #control [id]="'chipList' + dataDef.Enum + localId"  [disabled]="disabled">
    <mat-chip [id]="'opt' + dataDef.Enum + '_' + opt.Code + localId" *ngFor='let opt of options'
        [selected]='value == (useCodeAsValue ? opt.Code : opt.Id)' (click)="value = (useCodeAsValue ? opt.Code : opt.Id)" (selectionChange)="valueChangeHandler()">
        {{(dataDef.CodeNotRequired ? '' : (opt.Code ? opt.Code : '') + ' - ') + (opt.Description ? opt.Description : '')}}
    </mat-chip>
</mat-chip-list>
